import { ResponsiveBar } from '@nivo/bar';
import dayjs from '../../app/date';
import styled from 'styled-components';
import SubTitle from '../../components/SubTitle';

const Flex = styled.div`
  flex: 1;
  @media (max-width: 780px) {
    height: 500px !important;
  }
`;
const OverflowWrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
`;

const ChartWrapper = styled.div`
  height: 100%;
  @media (max-width: 780px) {
    min-width: 700px;
  }
`;

const GroupedAgeGroups = ({ data, keys, ageGroups }) => {
  const ageGroupsNames = ageGroups.map((region) => 'Vek ' + region.value);

  return (
    <Flex>
      <SubTitle>Počet čakajúcich podľa veku</SubTitle>
      <OverflowWrapper>
        <ChartWrapper>
          <ResponsiveBar
            data={data.filter((ageGroup) =>
              ageGroupsNames.includes(ageGroup.ageGroup)
            )}
            keys={keys.sort(
              (a, b) => dayjs(b, 'DD.MM.YYYY') - dayjs(a, 'DD.MM.YYYY')
            )}
            indexBy="ageGroup"
            margin={{ top: 25, right: 120, bottom: 110, left: 100 }}
            padding={0.3}
            groupMode="grouped"
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={{ scheme: 'paired' }}
            layout="horizontal"
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'Počet ľudí v čakárni',
              legendPosition: 'middle',
              legendOffset: 45,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'Veková skupina',
              legendPosition: 'middle',
              legendOffset: -80,
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            legends={[
              {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
          />
        </ChartWrapper>
      </OverflowWrapper>
    </Flex>
  );
};

export default GroupedAgeGroups;
